import {css, StyleSheet} from 'aphrodite';
import classnames from 'classnames';
import React from 'react';

import IndexSelectionGroup from 'molbio/IndexSelectionGroup';
import FormGroup from 'ui-library/bs/FormGroup';
import {BLUE_POWDER_LIGHT, GRAY_DARKER} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import FieldLabel from 'ui-library/inputs/FieldLabel';

import {sharedFormStyles, TranslationRegion} from './CreateEditTranslationForm';

interface TranslationPositionInputGroupProps {
  label: string;
  modelRange: TranslationRegion;
  setStart: (value: number | null) => void;
  setEnd: (value: number | null) => void;
  disabled: boolean;
  sequenceStartIndex: number;
  sequenceLength: number;
  regionLabelClassName?: string;
  onDeleteRegion?: ((regionId: number) => void) | null;
}

/**
 * A component with two text inputs for start and end positions of a translation or translation region
 * to be used in the form for creating and editing translations.
 */
function TranslationPositionInputGroup({
  label,
  modelRange,
  setStart,
  setEnd,
  disabled,
  sequenceStartIndex,
  sequenceLength,
  regionLabelClassName,
  onDeleteRegion,
}: TranslationPositionInputGroupProps): JSX.Element {
  return (
    <FormGroup
      className={classnames(css(sharedFormStyles.fieldRow), {
        [css(styles.selectedFieldRow)]: modelRange.selected,
      })}
    >
      <FieldLabel className={regionLabelClassName} label={label} />
      <div className={css(styles.positionFields)}>
        <IndexSelectionGroup
          updateEndIndex={setEnd}
          updateStartIndex={setStart}
          disabled={disabled}
          endIndex={modelRange.end}
          startIndex={modelRange.start}
          sequenceLength={sequenceLength}
          sequenceStartIndex={sequenceStartIndex}
        />
        {onDeleteRegion != null && (
          <BenchlingIcon
            className={css(styles.deleteIcon)}
            icon="close"
            onClick={() => {
              onDeleteRegion(modelRange.id!);
            }}
          />
        )}
      </div>
    </FormGroup>
  );
}

export const styles = StyleSheet.create({
  selectedFieldRow: {
    backgroundColor: BLUE_POWDER_LIGHT,
    padding: '4px 12px',
    marginBottom: '11px',
  },
  positionFields: {
    display: 'flex',
  },
  deleteIcon: {
    marginTop: '8px',
    marginLeft: '10px',
    width: '10px',
    height: '10px',
    color: GRAY_DARKER,
    cursor: 'pointer',
  },
});

export default TranslationPositionInputGroup;
